import AboutPageSection from "../../Components/AboutSections/AboutPageSection";
import PageBanner from "../../layout/Banner";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { Helmet } from "react-helmet";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Nyaysakti Chambers</title>
        <meta
          name="description"
          content="Learn about Nyaysakti Chambers, our legacy of legal excellence, integrity, and client-focused services. Experienced lawyers committed to justice and professionalism."
        />
        <meta
          name="keywords"
          content="Nyaysakti, Law Firm, About Us, Legal Experts, Attorneys, Legal Services, Justice"
        />
        <noscript>
          Please enable JavaScript to view this page properly.
        </noscript>
      </Helmet>
      <Header />
      <PageBanner title="About Us" subtitle="Get to know us" />
      <AboutPageSection />
      <Footer />
    </>
  );
};

export default AboutPage;
